export { default } from "./CeoMessage.jsx";
